class VideoControl extends HTMLElement {
  constructor() {
    super();
    this.videoElement = this.querySelector("video");
    this.playPauseButton = this.querySelector(".video-control");

    if (!this.videoElement || !this.playPauseButton) return;

    this.playPauseButton.addEventListener("click", () => {
      this.videoElement.focus(); // Ensure it gets focus before playing
      if (this.videoElement.paused) {
        this.videoElement.play().then(() => {
          this.playPauseButton.classList.add("playing");
        }).catch(() => {});
      } else {
        this.videoElement.pause();
        this.playPauseButton.classList.remove("playing");
      }
    });

    this.videoElement.addEventListener("ended", () => {
      this.playPauseButton.classList.remove("playing");
    });

    this.videoElement.addEventListener("click", () => {
      if (this.videoElement.paused) {
        this.videoElement.play().then(() => {
          this.playPauseButton.classList.add("playing");
        }).catch(() => {});
      } else {
        this.videoElement.pause();
        this.playPauseButton.classList.remove("playing");
      }
    });
  }
}

customElements.define('video-control', VideoControl);